import { createSelector } from 'reselect'
import { Session } from 'types/User/Session'
import { User } from 'types/User'
import { getPage } from 'selectors/page'
import { getUser } from './helpers'
import { PromoPayload, CTA, Item } from 'types/API/Easel/Promos'

export const getSession = createSelector([getUser], (user: User): Session => user.session || {})

export const getPromos = createSelector(
  [getSession],
  (session: Session): PromoPayload => session?.promos || {}
)

export const getPromoCampaigns = createSelector(
  [getSession, getPromos],
  (session, promos): Item[] => session?.promos?.items || []
)

export const getPromoCta = createSelector(
  [getSession, getPromos],
  (session, promos): CTA => session?.promos?.cta || {}
)

export const getPagePath = createSelector([getPage], (page): string => page.path || '')
